import { AxiosPromise } from "axios";
import { api } from "./common";

export function isApiDataOK(): AxiosPromise<string> {
  return api.get("/");
}
